import axiosInstance from '../Utils/axiosInstance';
import { TradeData, TradeType, UploadAction, UploadAfterValidateRequest, UploadAfterValidateResponse } from '../Types/TradeUpload';

export const uploadFileToAPI = async (
    file: File,
    tradeType: TradeType,
    action: UploadAction
): Promise<any> => {
    const API_ENDPOINT = `/paper-app/csv-trade-upload/?trade_type=${tradeType}`;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('action', action);

    try {
        const response = await axiosInstance.post(API_ENDPOINT, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        if ((error as any)?.response?.status === 400) {
            throw new Error('Invalid file format or trade type');
        } else if ((error as any)?.response?.status === 413) {
            throw new Error('File size is too large');
        } else if ((error as any)?.response?.status === 500) {
            throw new Error('Server error. Please try again later');
        } else if ((error as any)?.message === 'Network Error') {
            throw new Error('Network connection failed. Please check your internet');
        }
        throw error;
    }
};

export const uploadAfterValidateAPI = async (
    validatedData: TradeData[]
): Promise<UploadAfterValidateResponse> => {
    const body: UploadAfterValidateRequest = {
        validated: true,
        data: validatedData,
    };

    try {
        const response = await axiosInstance.post<UploadAfterValidateResponse>(
            `/paper-app/upload-aft-validate`,
            body,
            {
                headers: { 'Content-Type': 'application/json' },
            }
        );
        return response.data;
    } catch (error) {
        if ((error as any)?.response?.status === 400) {
            throw new Error('Invalid data for upload');
        } else if ((error as any)?.response?.status === 500) {
            throw new Error('Server error. Please try again later');
        } else if ((error as any)?.message === 'Network Error') {
            throw new Error('Network connection failed. Please check your internet');
        }
        throw error;
    }
};